module.exports = __webpack_public_path__ + "static/media/Amealio_Illustrations-06.f19751dc.svg";